import * as yup from 'yup';
import { RendererType } from '../data-models/field-definition';
import { eqBuyFields } from '../pages/Finance/components/TransactionModal/Forms/schemas/Equity/EquityBuySchema';
import { getRoundLabel } from '../util/preference-utils';

export function commonTransactionFields() {
  const roundLabel = getRoundLabel();
  return {
    companyId: yup.number().label('Company').required(),
    fundId: eqBuyFields().fundId,
    id: yup.number(),
    investmentAmount: eqBuyFields().investmentAmount,
    roundId: yup.number().label(roundLabel),
    investmentName: yup.string().label(roundLabel),
    transactionTypeId: yup.string().label('Transaction Type').required(),
  };
}

export function commonTransactionFormSchema() {
  return yup.object(commonTransactionFields());
}

export function commonTransactionGridSchema() {
  const fields = commonTransactionFields();
  const roundLabel = getRoundLabel();

  return yup.object({
    ...fields,
    /**
     * Grid only. The API derives it for ledger rows — assigned, pendingAssignment (still inside the
     * grace window), or unassigned — and it is null on every hand-entered row. Nobody types it, so
     * it must stay out of the fields the transaction form is built from.
     */
    assignmentStatus: yup.string().nullable().label(`${roundLabel} assignment`).gridMeta({
      // The id renderer is what wires a formatter into the keyCreator and the filter as well as the
      // cell: with a formatter alone the Set Filter lists the raw `pendingAssignment` and the group
      // rows key on it, while the cell beneath reads "Pending Assignment".
      renderer: RendererType.id,
      formatter: 'roundAssignmentStatus',
      enableRowGroup: true,
    }),
    companyId: fields.companyId.gridMeta({
      renderer: RendererType.companyId,
      enableRowGroup: true,
    }),
    fundId: eqBuyFields().investmentAmount.label('Fund').gridMeta({
      renderer: RendererType.id,
      formatter: 'fund',
      enableRowGroup: true,
    }),
    investmentAmount: eqBuyFields().investmentAmount.label('Amount').gridMeta({
      renderer: RendererType.currency,
    }),
    investmentName: fields.investmentName.gridMeta({ enableRowGroup: true }),

    transactionTypeId: fields.transactionTypeId.gridMeta({
      renderer: RendererType.id,
      formatter: 'transactionType',
      enableRowGroup: true,
    }),
  });
}

export type AbstractTransaction = yup.InferType<ReturnType<typeof commonTransactionFormSchema>>;
